import React, { useCallback, useEffect, useRef, useState } from 'react';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';

import SimpleDialog from '../Dialog/Dialog';
import Arquivo from '../Inputs/File/File';
import { ButtonPrimary, ButtonDefault } from '../Button/Button';
import { ToastCF } from '../Toast/Toast';

import ProvaService from '../../services/Prova';
import { descreverErro } from '../../services/API';

const useStyles = makeStyles(theme => ({
    contexto: {
        display: 'block',
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1.5, 2),
        borderRadius: 4,
        border: '1px solid #d6e0ff',
        borderLeft: `4px solid ${theme.palette.primary.main}`,
        backgroundColor: '#f2f6ff',
        fontWeight: 600,
        fontSize: 14,
    },
}));

const regiaoDaProva = prova => {
    if (!prova) return '--';

    return `${prova.regiao || '--'}${prova.regiaoGrupo ? ` / ${prova.regiaoGrupo}` : ''}`;
};

const DialogSubstituirCartao = ({ open, prova, onClose, onSubstituido }) => {
    const classes = useStyles();

    const arquivoRef = useRef(null);
    const [arquivoSelecionado, setArquivoSelecionado] = useState(null);
    const [enviando, setEnviando] = useState(false);
    const [toast, setToast] = useState({ open: false, message: '', type: 'error' });

    const notificar = useCallback((message, type = 'error') => setToast({ open: true, message, type }), []);

    useEffect(() => {
        if (!open) return;

        setArquivoSelecionado(null);
        setEnviando(false);
    }, [open, prova]);

    const handleClose = () => {
        if (enviando) return;

        if (onClose) onClose();
    };

    const handleArquivoChange = () => {
        const campo = arquivoRef.current;

        setArquivoSelecionado(campo ? campo.state.file : null);
    };

    const confirmar = async () => {
        if (enviando) return;

        const campo = arquivoRef.current;

        if (!campo || !campo.isValid()) return;

        setEnviando(true);

        try {
            const config = { headers: { 'content-type': 'multipart/form-data' } };
            const formData = new FormData();
            formData.append('cartao', campo.state.file);

            const resposta = await ProvaService.substituirCartao(prova.id, formData, config);

            if (onSubstituido) onSubstituido(resposta.data);
        } catch (error) {
            notificar(descreverErro(error));
        } finally {
            setEnviando(false);
        }
    };

    const acoes = (
        <>
            <ButtonPrimary
                name="Substituir Cartão"
                startIcon={<CheckOutlinedIcon />}
                onClick={confirmar}
                disabled={!arquivoSelecionado || enviando}
                style={{ margin: 4 }}
            />
            <ButtonDefault
                name="Cancelar"
                startIcon={<ClearOutlinedIcon />}
                onClick={handleClose}
                disabled={enviando}
                style={{ margin: 4 }}
            />
        </>
    );

    return (
        <>
            <ToastCF
                open={toast.open}
                message={toast.message}
                type={toast.type}
                handleClose={() => setToast(anterior => ({ ...anterior, open: false }))}
            />

            <SimpleDialog
                openDialog={Boolean(open)}
                title="Substituir Cartão Resposta"
                closeDialog={handleClose}
                actions={acoes}
                fullWidth={true}
                maxWidth="md"
            >
                {prova &&
                    <>
                        <Typography variant="body2" color="textSecondary" className={classes.contexto}>
                            Código da Prova: <b>{prova.codigo}</b> — Região de Registro: {regiaoDaProva(prova)} 
                            <br /><br />
                            Ao substituir este cartão, o <b>Processo de Corte e Leitura de Marcações</b> deste cartão será reiniciado automaticamente.
                        </Typography>

                        <Arquivo
                            parentRef={r => { arquivoRef.current = r; }}
                            accept=".jpg"
                            handleChange={handleArquivoChange}
                        />
                    </>
                }
            </SimpleDialog>
        </>
    );
};

export default DialogSubstituirCartao;
